import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ComboPackageDTO } from '../helpers/models/combo_package.model';
import { ComboPackageManagment } from '../_services/combo_package';
import { AlertService } from '../_helpers/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingService } from '../_services/routing.service';
import { ExcelService } from '../_services/excel.service';
import { Title } from '@angular/platform-browser';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-vendor-all-earning',
  templateUrl: './vendor-all-earning.component.html',
  styleUrls: ['./vendor-all-earning.component.scss']
})
export class VendorAllEarningComponent implements OnInit {
  showLoader: boolean = false;
  pageTitle: string = 'Vendor All Earning';
  @ViewChild('ngSearch', { static: false }) ngSearch!: ElementRef;
  @ViewChild('ngLimit', { static: false }) ngLimit!: ElementRef;
  @ViewChild('ngOrderBy', { static: false }) ngOrderBy!: ElementRef;
  @ViewChild('statusOrderBy', { static: false }) statusOrderBy!: ElementRef;
  orderBy: string = 'createdOn|-1';
  obKey: string = 'createdOn';
  obValue: number = -1;
  currentPage = 1;
  itemsPerPage = 5;
  statusOrderByinfo: string = "pastWeek";
  totalItems: number = 0;
  tabsArray: any[] = [];
  isBackPressed: boolean = false;
  allData: any;
  id: any;

  constructor(
    private comboPackageManagment: ComboPackageManagment,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public routing: RoutingService,
    private excelService: ExcelService,
    private title: Title
  ) { }

  async ngOnInit() {
    this.id =
      this.activatedRoute.snapshot.queryParamMap.get('id');
    this.title.setTitle(this.pageTitle);
    await this.getComboPackage();
  }

  backTabs() {
    this.tabsArray.pop();
    let info: any = this.tabsArray.length - 1;
    let elem = document.getElementById(`${this.tabsArray[info]}-tab`)
    if (elem) {
      this.isBackPressed = true;
      elem.click();
    }
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(
      this.allData,
      'Combo-Package-Managment'
    );
  }

  async decisionEvent(categoryData: any) {
    this.showLoader = true;
    if (categoryData.changingValue === 'viewport') {
    } else if (categoryData.changingValue === 'remove') {
    } else if (categoryData.changingValue === 'edit') {
    } else if (categoryData.changingValue === 'approve') {
    } else if (categoryData.changingValue === 'decline') {
    } else {
      this.alertService.show_alert('Please Select The Action', '', 'error');
    }
  }

  pageChanged(p: number) {
    this.currentPage = p;
    this.getComboPackage();
  }

  getComboPackage() {
    this.itemsPerPage = this.ngLimit?.nativeElement?.value ? this.ngLimit?.nativeElement?.value : this.itemsPerPage;
    this.orderBy = this.ngOrderBy?.nativeElement?.value ? this.ngOrderBy?.nativeElement?.value : this.orderBy;
    this.statusOrderByinfo = this.statusOrderBy?.nativeElement?.value ? this.statusOrderBy?.nativeElement?.value : this.statusOrderByinfo;
    this.obKey = this.orderBy.split('|')[0];
    this.obValue = parseInt(this.orderBy.split('|')[1]);
    this.totalItems = 0;
    this.allData = [];
    this.showLoader = true;
    this.comboPackageManagment.getAllEarning(this.id, this.statusOrderByinfo, this.currentPage, this.itemsPerPage, this.obKey, this.obValue).subscribe({
      next: (response: any) => {
        this.showLoader = false;
        if(response && response.isSuccess){
          this.totalItems = response.totalCount ? response.totalCount : 0;
          this.allData = response.data;
        }
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
      },
    });
  }

}

